import { fetchCurrentUser } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const SAVE_COMPANY_NOTIFICATION_PREFERENCES_REQUEST =
  'app/CompanyNotificationPreferencesPage/SAVE_COMPANY_NOTIFICATION_PREFERENCES_REQUEST';
export const SAVE_COMPANY_NOTIFICATION_PREFERENCES_SUCCESS =
  'app/CompanyNotificationPreferencesPage/SAVE_COMPANY_NOTIFICATION_PREFERENCES_SUCCESS';
export const SAVE_COMPANY_NOTIFICATION_PREFERENCES_ERROR =
  'app/CompanyNotificationPreferencesPage/SAVE_COMPANY_NOTIFICATION_PREFERENCES_ERROR';
export const SAVE_COMPANY_NOTIFICATION_PREFERENCES_CLEAR =
  'app/CompanyNotificationPreferencesPage/SAVE_COMPANY_NOTIFICATION_PREFERENCES_CLEAR';

// ================ Reducer ================ //

const initialState = {
  saveInProgress: false,
  saveError: null,
  saveSuccess: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SAVE_COMPANY_NOTIFICATION_PREFERENCES_REQUEST:
      return {
        ...state,
        saveInProgress: true,
        saveError: null,
        saveSuccess: false,
      };
    case SAVE_COMPANY_NOTIFICATION_PREFERENCES_SUCCESS:
      return {
        ...state,
        saveInProgress: false,
        saveSuccess: true,
      };
    case SAVE_COMPANY_NOTIFICATION_PREFERENCES_ERROR:
      return {
        ...state,
        saveInProgress: false,
        saveError: payload,
      };
    case SAVE_COMPANY_NOTIFICATION_PREFERENCES_CLEAR:
      return {
        ...state,
        saveError: null,
        saveSuccess: false,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const saveCompanyNotificationPreferencesRequest = () => ({
  type: SAVE_COMPANY_NOTIFICATION_PREFERENCES_REQUEST,
});

export const saveCompanyNotificationPreferencesSuccess = () => ({
  type: SAVE_COMPANY_NOTIFICATION_PREFERENCES_SUCCESS,
});

export const saveCompanyNotificationPreferencesError = error => ({
  type: SAVE_COMPANY_NOTIFICATION_PREFERENCES_ERROR,
  payload: error,
  error: true,
});

export const clearSaveCompanyNotificationPreferences = () => ({
  type: SAVE_COMPANY_NOTIFICATION_PREFERENCES_CLEAR,
});

// ================ Thunks ================ //

/**
 * Save company notification preferences to user's protectedData
 * Data structure stored in: user.attributes.profile.protectedData.companyNotificationPreferences
 * 
 * @param {Object} params - Notification preferences
 * @param {boolean} params.enabled - Master switch for receiving service request notifications
 * @param {string[]} params.serviceCategories - Array of service category keys
 * @param {string[]} params.regions - Array of region/municipality names
 * @param {number} params.radius - Distance in kilometers for radius-based notifications
 * @param {string} params.notificationFrequency - 'immediate', 'hourly', 'daily', 'weekly'
 * @param {Object} params.quietHours - { enabled: boolean, startTime: '22:00', endTime: '08:00' }
 * @param {string[]} params.notificationChannels - ['email', 'sms', 'inApp']
 */
export const saveCompanyNotificationPreferences = params => (dispatch, getState, sdk) => {
  dispatch(saveCompanyNotificationPreferencesRequest());

  const {
    enabled,
    serviceCategories,
    regions,
    radius,
    notificationFrequency,
    quietHours,
    notificationChannels,
  } = params;

  const companyNotificationPreferences = {
    enabled,
    serviceCategories,
    regions,
    radius,
    notificationFrequency,
    quietHours,
    notificationChannels,
  };

  return sdk.currentUser
    .updateProfile({
      protectedData: {
        companyNotificationPreferences,
      },
    })
    .then(response => {
      dispatch(saveCompanyNotificationPreferencesSuccess());
      return response;
    })
    .catch(e => {
      dispatch(saveCompanyNotificationPreferencesError(storableError(e)));
      throw e;
    });
};

/**
 * Load current user data to populate form with saved preferences
 */
export const loadData = () => {
  return fetchCurrentUser();
};
